<span class="cmdk-glyph" aria-hidden="true">
  <paper-icon [name]="glyph()" [size]="18" />
</span>

@if (prefix(); as active) {
  <span class="cmdk-pill" data-testid="cmdk-prefix-pill">
    <paper-icon [name]="active.icon" [size]="12" />
    <span class="cmdk-pill__label">{{ prefixLabel() }}</span>
    <paper-button
      class="cmdk-pill__clear"
      intent="ghost"
      size="xs"
      shape="icon"
      icon="x"
      [ariaLabel]="clearPrefixLabel()"
      data-testid="cmdk-prefix-clear"
      (click)="onClearPrefix()" />
  </span>
}

<span class="cmdk-field">
  <!-- The ghost sits behind a transparent input; the typed half is hidden
       rather than measured, so it stays aligned across all four font axes. -->
  @if (interim(); as heard) {
    <span class="cmdk-ghost cmdk-ghost--voice" aria-hidden="true">
      <span class="cmdk-ghost__typed">{{ query() }}</span><span class="cmdk-ghost__rest">{{ query() ? ' ' : '' }}{{ heard }}</span>
    </span>
  }

  @if (ghost(); as remainder) {
    <span class="cmdk-ghost" aria-hidden="true">
      <span class="cmdk-ghost__typed">{{ query() }}</span><span class="cmdk-ghost__rest">{{ remainder }}</span>
      <paper-kbd class="cmdk-ghost__key" keys="→" label="Right arrow" size="sm" />
    </span>
  }

  <input
    #field
    class="cmdk-input ph-mask"
    type="text"
    role="combobox"
    aria-expanded="true"
    aria-autocomplete="list"
    autocomplete="off"
    spellcheck="false"
    data-testid="cmdk-input"
    [attr.aria-controls]="listboxId()"
    [attr.aria-activedescendant]="activeDescendantId()"
    [attr.aria-label]="placeholder()"
    [placeholder]="placeholder()"
    [value]="query()"
    (input)="onInput($event)" />
</span>

@if (voice.supported()) {
  <span class="cmdk-voice" [class.is-listening]="voice.listening()">
    @if (voice.listening()) {
      <span class="cmdk-voice__wave" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></span>
    }
    <paper-button
      intent="ghost"
      size="sm"
      shape="icon"
      icon="mic"
      data-testid="cmdk-mic"
      [ariaLabel]="micLabel()"
      [ariaPressed]="voice.listening()"
      (click)="voiceToggled.emit()" />
  </span>
}

<paper-kbd class="cmdk-esc" keys="Esc" label="Escape" size="md" />
